import Vue from 'vue';
import Vuex from 'vuex';
import { make } from 'vuex-pathify';

import pathify from '@/libs/pathify';


Vue.use(Vuex);


function getColls() {
    return {
        branches: null,
        cases: null,
        claims: null,
        clients: null,
        enums: null,
        insurers: null,
        intervalSets: null,
        persons: null,
        settings: null,
        users: null,
        vehicleCategories: null,
        vehicles: null,
    };
}

function getInitialState() {
    return {
        ...getColls(),

        lastFetch: getColls(),

        currentUser: null,
        loggedIn: false,
    };
}

const mutations = {
    ...make.mutations(getInitialState()),

    resetState(state) {
        Object.assign(state, getInitialState());
    },
};


export default function (/* { ssrContext } */) {
    const Store = new Vuex.Store({
        modules: {},
        state: getInitialState(),
        mutations,
        plugins: [pathify.plugin],
        strict: process.env.DEV,
    });

    return Store;
}
